import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { removeAttr } from "../tools";

import type { JSX } from "react";

type ElementProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

type CustomIconProps = { fixedWidth?: boolean };
type IconComponentProps = ElementProps & CustomIconProps;

type IconComponent = (props: IconComponentProps) => JSX.Element;

function createIcon(name: IconProp): IconComponent {
    return (props: IconComponentProps) => {
        return (
            <span {...removeAttr(props, "fixedWidth")}>
                <FontAwesomeIcon icon={name} fixedWidth={props.fixedWidth} />
            </span>
        );
    };
}

export const DeleteIcon = createIcon("trash");
export const CloseIcon = createIcon("times");
export const CheckCircleIcon = createIcon("check-circle");
export const CheckIcon = createIcon("check");
export const WarningIcon = createIcon("exclamation-triangle");
export const ErrorIcon = createIcon("exclamation-circle");
export const InfoIcon = createIcon("info-circle");
export const EditIcon = createIcon("pencil-alt");
export const LoadingIcon = createIcon("ellipsis-h");
export const MenuIcon = createIcon("bars");
